import type { IRequestGetOne } from '../components/interfaces/requestGetOne';
import { ReportCategories } from '../../common/enums/reportCategories';
import { fetchJson } from '../store/fetch';

export async function acceptAndStartConsult(
    request: IRequestGetOne,
    reloadProcess: () => Promise<void>,
    addConsultReport: (reportCategory: ReportCategories) => Promise<void>
) {
    const url = `/api/requests/${request.id}/accept`;
    await fetchJson(url, 'POST');
    await reloadProcess();
    await addConsultReport(ReportCategories.consultReport);
}
